class CountrySelector extends HTMLElement {
  constructor() {
    super();
    this.onCountryChange = this.onCountryChange.bind(this);
  }

  connectedCallback() {
    this.countryElement = this.querySelector('[name="address[country]"]');
    console.log(this.countryElement);
    this.provinceElement = this.querySelector('[name="address[province]"]');

    if (this.countryElement) {
      this.countryElement.addEventListener("change", this.onCountryChange);

      const initialCountry = this.getAttribute("country") || "";
      if (initialCountry) {
        this.selectCountry(initialCountry);
      } else {
        this.onCountryChange();
      }
    }
  }

  disconnectedCallback() {
    if (this.countryElement) {
      this.countryElement.removeEventListener("change", this.onCountryChange);
    }
  }

  selectCountry(countryName) {
    const countryIndex = Array.from(this.countryElement.options).findIndex(
      (option) => option.textContent === countryName,
    );
    this.countryElement.selectedIndex = Math.max(0, countryIndex);
    this.countryElement.dispatchEvent(new Event("change"));
  }

  onCountryChange() {
    const selectedOption =
      this.countryElement.options[this.countryElement.selectedIndex];
    const provinces = selectedOption
      ? JSON.parse(selectedOption.getAttribute("data-provinces"))
      : [];
    this.provinceElement.parentElement.hidden = provinces.length === 0;

    if (provinces.length > 0) {
      this.provinceElement.innerHTML = provinces
        .map(
          (data) =>
            `<option value="${data[0]}"${data[1] === this.getAttribute("province") ? " selected" : ""}>${data[1]}</option>`,
        )
        .join("");
    }
  }
}

if (!customElements.get("country-selector")) {
  customElements.define("country-selector", CountrySelector);
}
